import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { NotificationModel, NotificationType } from '../components/notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private subject$ = new Subject<NotificationModel>();
  private idx$ = 0;

  constructor() { }

  getObservable(): Observable<NotificationModel> {
    return this.subject$.asObservable();
  }

  info(title: string, message: string, timeout = 3000) {
    this.subject$.next(new NotificationModel(this.idx$++, NotificationType.info, title, message, timeout));
  }

  success(title: string, message: string, timeout = 3000) {
    this.subject$.next(new NotificationModel(this.idx$++, NotificationType.success, title, message, timeout));
  }

  warning(title: string, message: string, timeout = 3000) {
    this.subject$.next(new NotificationModel(this.idx$++, NotificationType.warning, title, message, timeout));
  }

  error(title: string, message: string, timeout = 3000) {
    this.subject$.next(new NotificationModel(this.idx$++, NotificationType.error, title, message, timeout));
  }

}
